export const saveGroupInfo = (groupInfo) => {
  return {
    type : 'GROUP_INFO_SAVE',
    groupInfo
  }
};
